import {
	FormControl,
	FormLabel,
	FormErrorMessage,
	NumberInput,
	NumberInputField,
	NumberInputStepper,
	NumberIncrementStepper,
	NumberDecrementStepper,
	Flex,
	InputLeftElement,
	InputGroup,
	Box,
	Text,
} from "@chakra-ui/react";
import React from "react";
import { CaretDown, CaretUp } from "phosphor-react";
import { COLORS } from "../../../../Helper/Colors";

export const NumberInputForm = ({
	label,
	placeholder,
	name,
	value,
	error,
	touched,
	handleChange,
	precision = 0,
	isRequired = false,
	showPrefix = false,
	showTooltip = false,
	tooltip,
	inputBgColor = COLORS.light,
	...rest
}) => {
	return (
		<FormControl flex={1} isInvalid={!!error && touched}>
			<Flex alignItems={"center"} justifyContent={"space-between"}>
				{label && (
					<Box display={"flex"} flexDirection='row' alignItems={isRequired ? "start" : "center"}>
						<FormLabel htmlFor={name} textTransform={"capitalize"} marginRight={0}>
							{label}
						</FormLabel>
						{!!isRequired && (
							<Text alignItems={"start"} marginLeft={1} color={COLORS.red}>
								*
							</Text>
						)}
					</Box>
				)}
				{showTooltip && tooltip}
			</Flex>
			<InputGroup>
				{showPrefix && (
					<InputLeftElement
						pointerEvents='none'
						height={"100%"}
						color={COLORS.brand}
						fontSize='1.2em'
						children={rest.prefix ? rest.prefix : "$"}
					/>
				)}
				<NumberInput
					onChange={(val) => handleChange(name, val)}
					value={value}
					inputMode={precision > 0 ? "decimal" : "numeric"}
					id={name}
					name={name}
					allowMouseWheel={false}
					clampValueOnBlur={false}
					min={0}
					backgroundColor={inputBgColor}
					borderColor={COLORS.gray}
					size={!!rest.size ? rest.size : "lg"}
					className='custom-input'
					width={"100%"}
					precision={precision}
					{...rest}
				>
					<NumberInputField focusBorderColor='red.200' placeholder={placeholder} paddingLeft={showPrefix ? 8 : 4} />
					<NumberInputStepper borderColor={"transparent"} marginRight={2}>
						<NumberIncrementStepper
							bg='transparent'
							borderColor={"transparent"}
							children={<CaretUp size={16} color={COLORS.brand} weight={"bold"} />}
						/>
						<NumberDecrementStepper
							bg='transparent'
							borderColor={"transparent"}
							children={<CaretDown size={16} color={COLORS.brand} weight={"bold"} />}
						/>
					</NumberInputStepper>
				</NumberInput>
			</InputGroup>
			<FormErrorMessage>{error}</FormErrorMessage>
		</FormControl>
	);
};
